var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from "vue-property-decorator";
import ContactInformation from "./ContactInformation.vue";
var Coordinators = /** @class */ (function (_super) {
    __extends(Coordinators, _super);
    function Coordinators() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], Coordinators.prototype, "coordinators", void 0);
    __decorate([
        Prop({ type: String })
    ], Coordinators.prototype, "generalEmail", void 0);
    __decorate([
        Prop({ type: String })
    ], Coordinators.prototype, "emailSubject", void 0);
    __decorate([
        Prop({ type: String })
    ], Coordinators.prototype, "generalPhoneNumber", void 0);
    Coordinators = __decorate([
        Component({
            name: "Coordinators",
            components: {
                ContactInformation: ContactInformation
            }
        })
    ], Coordinators);
    return Coordinators;
}(Vue));
export default Coordinators;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Components/Coordinators.vue
// module id = 168
// module chunks = 0 1 5